<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [showHeader]="false"
  [style]="{ width: '540px', 'max-width': '95vw', 'max-height': '90vh' }"
  [contentStyle]="{ overflow: 'auto', padding: '0' }"
  styleClass="vpd-dialog dialog-wave-redesign"
  maskStyleClass="dialog-wave-redesign-mask"
  (onHide)="onHide()">

  <!-- HEADER WAVE (mesmo padrao do dialog "Forma de Pago") -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-shopping-cart" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'vendas.detalhe.titulo' | translate }}</h2>
        <p *ngIf="produto">{{ produto.nome }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div *ngIf="produto" class="vpd-content">
    <!-- Carrossel (lazy: monta com produto presente) -->
    <div class="vpd-carrossel-wrapper">
      <app-item-imagens-carrossel
        [itemId]="produto.id"
        [imagemPrincipalUrl]="produto.imagem"
        [idEmpresa]="idEmpresa"
        [alt]="produto.nome">
      </app-item-imagens-carrossel>
    </div>

    <!-- Dados do produto -->
    <div class="vpd-dados">
      <h3 class="vpd-nome">{{ produto.nome }}</h3>
      <p class="vpd-codigo">
        {{ 'vendas.table.cod' | translate }} {{ produto.codigoItem }}
      </p>
      <p class="vpd-preco" *ngIf="moedaPadrao === 'PYG'">{{ produto.precoDeVenda | guaraniFormat }}</p>
      <p class="vpd-preco" *ngIf="moedaPadrao !== 'PYG'">
        {{ produto.precoDeVenda | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}
      </p>
      <p class="vpd-descricao" *ngIf="produto.descricao">{{ produto.descricao }}</p>
    </div>

    <!-- Quantidade -->
    <div class="vpd-quantidade">
      <label class="vpd-quantidade-label">{{ 'vendas.detalhe.label_quantidade' | translate }}</label>
      <p-inputNumber
        [(ngModel)]="quantidade"
        [min]="1"
        [showButtons]="true"
        buttonLayout="horizontal"
        spinnerMode="horizontal"
        incrementButtonIcon="pi pi-plus"
        decrementButtonIcon="pi pi-minus"
        [step]="1"
        styleClass="vpd-input-quantidade">
      </p-inputNumber>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="vpd-actions">
      <button pButton type="button"
        class="p-button-secondary"
        [label]="('vendas.detalhe.botao_cancelar' | translate) + ' (Esc)'"
        icon="pi pi-times"
        (click)="cancelar()">
      </button>
      <button pButton type="button"
        class="btn-primary"
        [label]="('vendas.detalhe.botao_adicionar_carrinho' | translate) + ' (Enter)'"
        icon="pi pi-shopping-cart"
        [disabled]="!podeAdicionar()"
        [loading]="adicionando"
        (click)="confirmar()">
      </button>
    </div>
  </ng-template>
</p-dialog>
